var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureindoorrowing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.2891 20.9648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 20.9648,
    opacity: 0,
    width: 22.2891,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23047 5.12109C8.66016 5.12109 9.79688 3.97266 9.79688 2.55469C9.79688 1.13672 8.66016 0 7.23047 0C5.8125 0 4.67578 1.13672 4.67578 2.55469C4.67578 3.97266 5.8125 5.12109 7.23047 5.12109ZM1.03125 14.0273C0.515625 15.9609 1.74609 17.1914 3.25781 17.1914C3.73828 17.1914 4.24219 17.0742 4.73438 16.8047L11.0977 13.418L18.1406 16.9453C18.9961 17.3672 19.6875 17.0273 19.957 16.4766C20.2148 15.9375 20.0508 15.1992 19.2305 14.7891L11.8594 11.0859C11.3789 10.8398 10.8516 10.8164 10.3477 11.0391L5.58984 13.1016L6.55078 9.75C6.72656 9.17578 7.25391 8.75391 7.86328 8.75391L17.3438 8.75391C18.0117 8.75391 18.5508 8.21484 18.5508 7.54688C18.5508 6.89062 18.0117 6.33984 17.3438 6.33984L6.98438 6.33984C4.64062 6.33984 2.73047 7.6875 2.19141 9.71484ZM0.65625 20.9414L21.2812 20.9414C21.6445 20.9414 21.9375 20.6602 21.9375 20.2969C21.9375 19.9336 21.6445 19.6406 21.2812 19.6406L0.65625 19.6406C0.28125 19.6406 0 19.9336 0 20.2969C0 20.6602 0.28125 20.9414 0.65625 20.9414Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureindoorrowing);
export default __webpack_public_path__ + "static/media/figure.indoor.rowing.f16a6ced8ecff3eda2f436b9f177795e.svg";
export { ForwardRef as ReactComponent };